export default __webpack_public_path__ + "static/media/btn-pin-round-on-30.7c127cf8.svg";